(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
function process_owl_event(evt) {
  var owl = $( "#the-index-hero");
  if( owl.length )
  {
    switch ( evt.originalEvent.type ) {
      case "shopify:section:load" : 
        console.log('Load ' + owl.attr("id"));
        owl.on('initialized.owl.carousel',function(event) {
          var element = $(event.target); 
          owl.show().css('opacity','1').css('visibility','visible');
        });
        owl.owlCarousel({
          loop:true,
          margin: 0,
          nav: false,
          lazyLoad: false,
          dots: true,
          items: 1,
          navText: [
            OwlArrowPrev,
            OwlArrowNext
          ]

        });
      break; 
      case "shopify:section:unload" :
        console.log('Unload ' + owl.attr("id"));
        
      break;

     } 
  }
}
    
document.addEventListener( 'DOMContentLoaded', function () {
  $(document)
   .on( 'shopify:section:load shopify:section:unload', process_owl_event );
}, false );


  } catch(e) { console.error(e); }
})();
})();
